import * as React from 'react';
import { MessageBanner } from './MessageBanner';
import { transformDYTemplateVariables } from './utils';

export interface DyMessageBannerData {
  text: string;
  fontSize: string;
  fontWeight: string;
  backgroundColor: string;
  fontColor: string;
  button: {
    variant: string;
    text: string;
    linkUrl: string;
    linkTarget: string;
  };
}

export interface DYMessageBannerProps {
  data: DyMessageBannerData;
  onClick: VoidFunction;
}

export const DYMessageBanner: React.FC<DYMessageBannerProps> = ({ data, onClick }) => {
  const props = transformDYTemplateVariables(data);
  return <MessageBanner onClick={onClick} {...props} />;
};
